module.exports = __webpack_public_path__ + "static/media/Gallient.ecce6fb9.ttf";